// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'jsx' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SerializedStyles, css, jsx } from "@emotion/react";
import { useCallback, useEffect } from "react";
import * as React from "react";

import { useInfiniteScroll } from "hooks/use-infinite-scroll";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const infiniteScrollStyles = (height: number) => css`
  height: ${height};
  overflow: auto;
`;

interface IProps {
  css?: SerializedStyles;
  children: React.ReactNode;
  className?: string;
  hasMore: boolean;
  height: number;
  isLoading: boolean;
  listRef: React.RefObject<HTMLElement>;
  onContainerRef: (ref: HTMLDivElement) => void;
  onLoadMore: () => void;
  threshold: number;
}

export const InfiniteScroll: React.FC<IProps> = ({
  children,
  className,
  isLoading,
  listRef,
  hasMore,
  height,
  onContainerRef,
  onLoadMore,
  threshold,
  css: innerCss,
}) => {
  const handleLoadMore = useCallback(() => {
    if (hasMore) {
      onLoadMore();
    }
  }, [hasMore, onLoadMore]);
  const containerRef = useInfiniteScroll(listRef, isLoading, threshold, handleLoadMore);

  useEffect(() => {
    // @ts-expect-error TS(2345): Argument of type 'HTMLDivElement | null' is not as... Remove this comment to see the full error message
    onContainerRef(containerRef.current);
  }, [containerRef, onContainerRef]);

  return (
    <div
      className={className}
      css={[infiniteScrollStyles(height), innerCss]}
      style={{ height, overflow: "auto" }}
      ref={containerRef}
    >
      {children}
    </div>
  );
};

InfiniteScroll.defaultProps = {
  className: "",
};
